import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-20 px-4" data-id="element-31">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-33">
          Your Dog Deserves Peace. <br data-id="element-34" />
          <span className="text-orange-400" data-id="element-35">You Deserve Freedom.</span>
        </h2>

        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-36">
          Stop feeling guilty. Stop worrying about complaints. Start living the
          life you both deserve.
        </p>

        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl px-12 py-6 rounded-full shadow-2xl inline-flex items-center gap-3 transition-all duration-300 animate-pulse" data-id="element-37">
          YES! I WANT A CALM DOG — GET INSTANT ACCESS FOR $37
          <ArrowRight className="w-6 h-6" data-id="element-38" />
        </motion.button>

        <p className="text-sm text-slate-400 mt-6" data-id="element-39">
          Instant digital delivery • 60-Day Money Back Guarantee
        </p>
      </motion.div>
    </section>;
}